export const defaultToZeroIfNegative = (number: number): number => Math.max(number, 0);
